-- | Utility functions for working with JSON.
module Internal.JsonUtil where

import Common

import Data.Argonaut (Json, JsonDecodeError(..), isNumber, isString, printJsonDecodeError, toArray, toNumber, toObject, toString, (.:))
import Data.Array ((!!))
import Data.Either (Either(..), note)
import Data.Int (floor)
import Data.Maybe (Maybe(..))
import Foreign.Object (Object)


-- | Checks if the given `Json` is an object. Returns the object if so,
-- | otehrwise returns a `JsonDecodeError`.
assertObject :: Json -> Either JsonDecodeError (Object Json)
assertObject json = case toObject json of
    Just obj -> Right obj
    Nothing -> Left $ TypeMismatch "Expected object"

-- | Checks if the given `Json` is an array. Returns the array if so,
-- | otehrwise returns a `JsonDecodeError`.
assertArray :: Json -> Either JsonDecodeError (Array Json)
assertArray json = case toArray json of
    Just arr -> Right arr
    Nothing -> Left $ TypeMismatch "Expected array"

-- | Converts `JsonDecodeError`s into string representations.
jsonErrToString :: forall a. Either JsonDecodeError a -> Either String a
jsonErrToString (Left err) = Left $ printJsonDecodeError err
jsonErrToString (Right val) = Right val


-- | Gets the value of the element at the given json path. Returns a decode
-- | error on failure.
lookupPath :: JsonPath -> Json -> Either JsonDecodeError Json
lookupPath path json = foldM (\j p -> lookupPathElem p j) json path

lookupPathElem :: JsonPathElem -> Json -> Either JsonDecodeError Json
lookupPathElem (ObjectKey key) json = assertObject json >>= (_ .: key)
lookupPathElem (ArrayIndex idx) json = assertArray json >>= (\j -> note err (j !! idx))
    where err = AtIndex idx MissingValue


numberToString :: Json -> Either JsonDecodeError String
numberToString j | isString j = note (TypeMismatch "String") $ toString j
numberToString j | isNumber j = note (TypeMismatch "Number") $ show <$> floor <$> toNumber j
numberToString _ = Left $ TypeMismatch "String or Number"

-- | Represents a path to a value in a JSON object as a list of strings or
-- | array indices.
type JsonPath = Array JsonPathElem

-- | Element of a JSON path.
data JsonPathElem = ObjectKey String | ArrayIndex Int

